<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;" class="fontMS700 colorPrincipal font-45">
            REPORTAJE Y PROPAGANDA: <br>
            <span style="line-height: 100%;" class="fontMS300">
                NOTICIARIOS CINEMATOGRÁFICOS <br> PERUANOS DE LOS 40 (PARTE II)<br>
            </span>
        </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio42/noticieros2">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio42/noticieros2">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio42/noticieros2">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img class="img_portada" src="/assets/images/micrositio/micrositio18/NOTIC_000.jpg">
</section>

<div class="fondoBlanco_Intro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12 d-none d-md-block">
                <div class="image-container">
                    <img class="bg-image" src="/assets/images/micrositio/micrositio42/NOTICIERO-001.png" alt="Noticiero">
                    <div class="text-overlay">
                        <p class="fontMS100 font-24">
                            HACIA LA DÉCADA DE 1940, EL CINE YA SE HABÍA 
                            CONSOLIDADO COMO UN MEDIO MASIVO DE 
                            COMUNICACIÓN EN TODA AMÉRICA LATINA, Y COBRÓ 
                            PARTICULAR IMPORTANCIA EN LA CONFIGURACIÓN DE 
                            IDENTIDADES NUEVAS Y AUDIENCIAS MASIVAS. 
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 d-md-none">
                <p class="fontMS100 font-24 text-justify">
                            HACIA LA DÉCADA DE 1940, EL CINE YA SE HABÍA 
                            CONSOLIDADO COMO UN MEDIO MASIVO DE 
                            COMUNICACIÓN EN TODA AMÉRICA LATINA, Y COBRÓ 
                            PARTICULAR IMPORTANCIA EN LA CONFIGURACIÓN DE 
                            IDENTIDADES NUEVAS Y AUDIENCIAS MASIVAS. 
                </p>
            </div>
            <div class="col-sm-12">
                <p class="fontMS100 font-24 text-justify">
                    <br><br>
                    LA BIBLIOTECA NACIONAL PRESERVA ROLLOS DE FILME DE 35 MILÍMETROS DE NOTICIARIOS FINANCIADOS 
                    POR EL ESTADO ENTRE LOS AÑOS DE 1944 Y 1948. LOS CUALES SE EXHIBÍAN EN LAS SALAS DE CINE PREVIOS 
                    A LA EMISIÓN DE PELÍCULAS. LA DIGITALIZACIÓN DE ESTE MATERIAL FÍLMICO EN EL 2016, NOS PERMITE 
                    ACCEDER AL TESTIMONIO AUDIOVISUAL DE UN PERÍODO SIGNIFICATIVO PARA LA HISTORIA DEL PERÚ, QUE 
                    ABARCA LA ÉPOCA POST CONFLICTO BÉLICO CON ECUADOR (JULIO-AGOSTO DE 1941), EL FINAL DE LA 
                    SEGUNDA GUERRA MUNDIAL, LAS APERTURAS MODERNIZADORAS, LA TRANSICIÓN DEMOCRÁTICA Y, 
                    FINALMENTE, LA CRISIS POLÍTICA QUE CONLLEVARÍA A UN NUEVO GOLPE DE ESTADO. LA COMPLEJA 
                    DÉCADA DE 1940, ESTÁ DOCUMENTADA, ADEMÁS, CON NOTICIAS SOBRE DEPORTE, MILICIA, EDUCACIÓN Y 
                    VIDA COTIDIANA EN LIMA Y EN LAS DEMÁS REGIONES DEL PAÍS EN UN ESFUERZO DESCENTRALIZADOR.
                    <br><br>
                </p>
            </div>
            <div class="col-sm-12 d-none d-md-block">
                <div class="image-container">
                    <img class="bg-image" src="/assets/images/micrositio/micrositio42/NOTICIERO-002.png" alt="Noticiero">
                    <div class="text-overlay2">
                        <div class="row">
                            <div class="col-sm-12 mt-5 videoReprod">
                                <a id="123" class="video3" href="https://www.youtube.com/embed/wFwo9QZQ5nM" target="_blank" style="color: black;">
                                    <img width="100%" src="http://img.youtube.com/vi/wFwo9QZQ5nM/hqdefault.jpg" />
                                </a>
                            </div>
                        </div>
                        <p class="fontMS100Italic font-16 text-justify">
                            <br>
                            Homenaje de los marinos británicos al Almirante Grau. Lima[: Productora Huascarán], 194? Video en blanco y negro. 1´30”. Reproducción digital. 
                            Noticiario cinematográfico de la década de 1940 sobre el desfile de los marineros ingleses frente al monumento de Miguel Grau en homenaje al 
                            marino peruano. Originalmente grabado en un rollo de película de nitrato de celulosa de 35 mm, en formato analógico. Archivo en formato MP
                            <br>
                        </p>
                        <p class="fontMS100Italic font-16 text-center">
                            Disponible en: 
                            <a href="http://hdl.handle.net/20.500.14428/79925" target="_blank" style="color: #ffffff;">
                                Biblioteca Digital
                            </a>
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 d-md-none">
                <div class="image-container3">
                    <div class="text-overlay3">
                        <div class="row">
                            <div class="col-sm-12 mt-5 videoReprod">
                                <a id="123" class="video3" href="https://www.youtube.com/embed/wFwo9QZQ5nM" target="_blank" style="color: black;">
                                    <img width="100%" src="http://img.youtube.com/vi/wFwo9QZQ5nM/hqdefault.jpg" />
                                </a>
                            </div>
                        </div>
                        <p class="fontMS100Italic font-18 text-justify">
                            Homenaje de los marinos británicos al Almirante Grau. Lima[: Productora Huascarán], 194? Video en blanco y negro. 1´30”. Reproducción digital. 
                            Noticiario cinematográfico de la década de 1940 sobre el desfile de los marineros ingleses frente al monumento de Miguel Grau en homenaje al 
                            marino peruano. Originalmente grabado en un rollo de película de nitrato de celulosa de 35 mm, en formato analógico. Archivo en formato MP
                            <br><br>
                            Disponible en: 
                            <a href="http://hdl.handle.net/20.500.14428/79925" target="_blank" style="color: #ffffff;">
                                Biblioteca Digital
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoOscuro">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio42/NOTICIERO-LINEA-001.png" width="90%" style="margin-left: 5%">
                
                <div class="row ">
                    <div class="col"></div>
                    <div class="col-sm-10">
                        <p class="text-center text-white fontMS100Italic font-24">
                            <br>
                            <span class="text-justify ">
                                <br><br>
                                DESDE LOS ORÍGENES DEL CINE, LOS NOTICIARIOS SE CONVIRTIERON EN UN EJE FUNDAMENTAL 
                                DE LA EXPANSIÓN DEL FENÓMENO CINEMATOGRÁFICO, DEBIDO A QUE FUERON LOS ÚNICOS QUE 
                                PROPORCIONARON A LOS ESPECTADORES UNA INFORMACIÓN AUDIOVISUAL DE LO QUE PASABA EN 
                                EL MUNDO, DURANTE TODA LA PRIMERA MITAD DEL SIGLO XX. 
                                <br><br>
                                <span class="fontMS100Italic">
                                    
                                </span>
                                <br><br>
                            </span>
                        </p>

                    </div>
                    <div class="col"></div>
                </div>
                
                <img src="/assets/images/micrositio/micrositio42/NOTICIERO-LINEA-002.png" class="reflejo"
                    width="90%" style="margin-left: 5%">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <p class="fontMS100 font-24 text-justify">
                    <br><br>
                    EL NACIMIENTO DE LOS NOTICIARIOS MODERNOS EN ESTADOS UNIDOS (1905) Y EN FRANCIA (1908) 
                    CON PATHÉ, DA UN CARÁCTER MÁS ESTRICTAMENTE INFORMATIVO A LAS IMÁGENES PROYECTADAS: 
                    CON LA PERIODICIDAD REGULAR DE LAS EDICIONES DE INFORMACIÓN FILMADA, SE IMPUSO UN 
                    CIERTO CRITERIO PERIODÍSTICO EN LA SELECCIÓN DE TEMAS Y UNA ORGANIZACIÓN ACORDE CON 
                    ESTE OBJETIVO (RED DE CORRESPONSALES, MEDIOS RÁPIDOS DE EMISIÓN O DIFERENTES EDICIONES 
                    PROVINCIALES Y NACIONALES).<br> LOS NOTICIEROS PRESENTARON ACONTECIMIENTOS POLÍTICOS, SOCIALES, 
                    DEPORTIVOS, FIESTAS POPULARES, DESASTRES O ANÉCDOTAS CURIOSAS RECOGIDAS POR LAS CÁMARAS 
                    DE LOS OPERADORES.
                    <br><br>
                </p>
            </div>
            <div class="col-sm-12 d-none d-md-block">
                <div class="image-container">
                    <img class="bg-image" src="/assets/images/micrositio/micrositio42/NOTICIERO-002.png" alt="Noticiero">
                    <div class="text-overlay2">
                        <div class="row">
                            <div class="col-sm-12 mt-5 videoReprod">
                                <a id="123" class="video3" href="https://www.youtube.com/embed/oJZ0zuBB_pM" target="_blank" style="color: black;">
                                    <img width="100%" src="https://img.youtube.com/vi/oJZ0zuBB_pM/hqdefault.jpg" />
                                </a>
                            </div>
                        </div>
                        <p class="fontMS100Italic font-16 text-justify">
                            <br>
                            [Celebraciones del 14 de julio. París]. París, 1932. Video en blanco y negro. 3´31”. El intertítulo dice: "La Revue". Contenido: Llegada en coche del 
                            presidente francés y entonces ministro de la Guerra, Edouard Daladier. Medallas entregadas a los soldados. Gran desfile militar ante una multitud 
                            entusiasta. Los tanques y los cañones de campaña móviles también forman parte del desfile, al igual que un desfile aéreo. Entre los dignatarios se 
                            encuentra Edouard Herriot, primer ministro de Francia. Vistas de un vuelo que pasa por encima de un avión. Más tomas del desfile. Muchos pequeños 
                            tanques y vehículos blindados. 
                            <br>
                        </p>
                        <p class="fontMS100Italic font-16 text-center">
                            Disponible en: 
                            <a href="https://www.youtube.com/watch?v=oJZ0zuBB_pM" target="_blank" style="color: #ffffff;">
                                https://www.youtube.com/watch?v=oJZ0zuBB_pM
                            </a>
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 d-md-none">
                <div class="image-container3">
                    <div class="text-overlay3">
                        <div class="row">
                            <div class="col-sm-12 mt-5 videoReprod">
                                <a id="123" class="video3" href=" https://www.youtube.com/embed/oJZ0zuBB_pM" target="_blank" style="color: black;">
                                    <img width="100%" src="https://img.youtube.com/vi/oJZ0zuBB_pM/hqdefault.jpg" />
                                </a>
                            </div>
                        </div>
                        <p class="fontMS100Italic font-18 text-justify"><br>
                            [Celebraciones del 14 de julio. París]. París, 1932. Video en blanco y negro. 3´31”. El intertítulo dice: "La Revue". Contenido: Llegada en coche del 
                            presidente francés y entonces ministro de la Guerra, Edouard Daladier. Medallas entregadas a los soldados. Gran desfile militar ante una multitud 
                            entusiasta. Los tanques y los cañones de campaña móviles también forman parte del desfile, al igual que un desfile aéreo. Entre los dignatarios se 
                            encuentra Edouard Herriot, primer ministro de Francia. Vistas de un vuelo que pasa por encima de un avión. Más tomas del desfile. Muchos pequeños 
                            tanques y vehículos blindados. 
                            <br><br>
                            Disponible en: 
                            <a href="https://www.youtube.com/watch?v=oJZ0zuBB_pM" target="_blank" style="color: #ffffff;">
                                https://www.youtube.com/watch?v=oJZ0zuBB_pM
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoOscuro">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio42/NOTICIERO-LINEA-001.png" width="90%" style="margin-left: 5%">
                
                <div class="row ">
                    <div class="col"></div>
                    <div class="col-sm-10">
                        <p class="text-center text-white fontMS100Italic font-24">
                            <br>
                            <span class="text-justify ">
                                <br><br>
                                «LAS IMÁGENES DE ACTUALIDAD CAUSARON UN IMPACTO QUE ATRAJO A UN NÚCLEO IMPORTANTE DE 
                                ESPECTADORES QUE, POR SU TEMPERAMENTO O FORMACIÓN, NUNCA HABÍAN TENIDO UNA RELACIÓN 
                                ESTRECHA CON LA ABSTRACCIÓN PROPÍA DE LOS MENSAJES PROCEDENTES DE LA PRENSA ESCRITA. 
                                MOTIVADO POR PRIMERA VEZ A INTERESARSE POR LA INFORMACIÓN GRACIAS A LA CONCRECIÓN MUCHO 
                                MÁS ACCESIBLE DE LAS NOTICIAS EN FORMATO CINEMATOGRÁFICO, ESTE PÚBLICO ELABORÓ UNA IDEA 
                                DEL MUNDO A TRAVÉS DE LA PRENSA FILMADA. EN ESTE SENTIDO, LA INFLUENCIA DE LOS 
                                NOTICIARIOS LLEGARÁ A SER ENORME SOBRE TODO EN LOS PAÍSES MENOS DESARROLLADOS, 
                                PARTICULARMENTE REPECTIVOS A LAS IMÁGENES CINEMATOGRÁFICAS, Y QUE, HASTA NO HACE MUCHO, 
                                NO DISPUSIERON DE OTRAS FUENTES O MEDIOS DE INFORMACIÓN». 
                                <br><br>
                                <span class="fontMS100Italic">
                                    (MARÍA ANTONIA PAZ E INMACULADA SÁNCHEZ. «LA HISTORIA FILMADA: LOS NOTICIARIOS 
                                    CINEMATOGRÁFICOS COMO FUENTE HISTÓRICA. UNA PROPUESTA METODOLÓGICA». 1999)
                                </span>
                                <br><br>
                            </span>
                        </p>

                    </div>
                    <div class="col"></div>
                </div>
                
                <img src="/assets/images/micrositio/micrositio42/NOTICIERO-LINEA-002.png" class="reflejo"
                    width="90%" style="margin-left: 5%">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
                <div class="row">

                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio42/NOTICIERO-LINEA-003.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-30">
                            PRODUCCIÓN DE LOS <br>
                            NOTICIARIOS <br>
                            CINEMATOGRÁFICOS<br>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio42/NOTICIERO-LINEA-003.png">
                    </div>
                </div>

                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio42/NOTICIERO-LINEA-003.png">
                </div>
        
        <div class="row">
            <div class="col-sm-6">
                <p class="fontMS100 font-24 text-justify">
                    <br><br>
                    EN EL PRIMER GOBIERNO DE MANUEL PRADO, SE DISEÑÓ 
                    UNA POLÍTICA ORIENTADA A LA DIFUSIÓN DE LAS 
                    INICIATIVAS GUBERNAMENTALES. UNA DE ESTAS 
                    INICIATIVAS FUE EL DOCUMENTAL SOBRE EL CONFLICTO 
                    CON EL ECUADOR OCURRIDO EN 1941 TITULADO: ALERTA 
                    EN LA FRONTERA, DIRIGIDO POR KURT HERMANN. SIN 
                    EMBARGO, LA JUNTA DE CENSURA PROHIBIÓ ESTE 
                    DOCUMENTAL, ALEGANDO 
                    <span class="fontMS500">
                    «MOTIVOS DE 
                    INOPORTUNIDAD PARA LAS RELACIONES EXTERIORES 
                    DEL PAÍS, SIMILARES A LAS QUE LLEVARON A LA 
                    INTERDICCIÓN DE PÁGINAS HEROICAS». 
                    </span>
                    AÑOS DESPUÉS, A TRAVÉS DE LA DIRECCIÓN DE 
                    PROPAGANDA E INFORMACIÓN Y LA OFICINA DE
                    <br><br>
                </p>
            </div>
            <div class="col-sm-6">
                <p class="fontMS100 font-24 text-justify">
                    <br><br>
                    INFORMACIONES, AMBAS ADSCRITAS AL MINISTERIO DE 
                    GOBIERNO Y POLICÍA, SE PLANIFICÓ EL CONTENIDO DEL 
                    SERVICIO DE NOTICIARIOS NACIONALES, CREADO EN 
                    JULIO DE 1944, QUE IMPULSÓ LA REALIZACIÓN DE UN 
                    NOTICIARIO DE PERIODICIDAD SEMANAL, ASÍ COMO LA 
                    ELABORACIÓN DE DOCUMENTALES QUE DEBÍAN 
                    EXHIBIRSE DE FORMA OBLIGATORIA EN TODAS LAS SALAS 
                    DE CINE DEL PAÍS. ADEMÁS, SE DESIGNÓ A EMPRESAS 
                    PRODUCTORAS QUE DESARROLLARÍAN LOS FILMS Y SE 
                    LES REMUNERABA EN RELACIÓN CON EL METRAJE. 
                    ALGUNAS DE LAS EMPRESAS PRODUCTORAS FUERON: 
                    PRODUCTORA HUASCARÁN, NACIONAL FILMS, PERÚ 
                    SONO FILMS, ENTRE OTRAS.
                    <br><br>
                </p>
            </div>
        </div>
    </div>
</div>

<div class="fondoOscuro">
    <img src="/assets/images/micrositio/micrositio42/NOTICIERO_LINEA_004.png" width="90%" style="margin-left: 5%">

    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="row ">
                    <div class="col-sm-5">
                                <br><br>
                                <div class="row">
                                    <div class="col-sm-12 mt-5 videoReprod">
                                        <a id="123" class="video3" href="https://www.youtube.com/embed/Evd42DL0ySs" target="_blank" style="color: black;">
                                            <img width="100%" src="https://img.youtube.com/vi/Evd42DL0ySs/hqdefault.jpg" />
                                        </a>
                                    </div>
                                </div>
                                <p class="fontMS100Italic font-14 text-justify text-white">
                                    <br>
                                    Alerta en la frontera. Lima: Nacional Films, Federico Uranga, 1941. Video en blanco y negro. 60´. 
                                    Dirección: Kurt Hermann. Fotografía: Manuel Trullen y Pedro Valdivieso. <br>
                                    «Vino (…) el conflicto con el Ecuador y con el señor Federico Uranga hicimos una película de una hora de 
                                    duración. La película fue autorizada por el Estado Mayor [del Ejército] resultando muy interesante. Tenía 
                                    el lanzamiento de los paracaidistas en Machala, el cruce del río Zarumilla y muchos aspectos interesantes 
                                    del conflicto hasta el arreglo de Talara» (Testimonio de Manuel Trullen reproducido por Ricardo Bedoya)
                                    <br><br>
                                    Disponible en: 
                                    <a href="http://hdl.handle.net/20.500.14428/82534" target="_blank" style="color: #ffffff;">
                                        Biblioteca Digital<br><br>
                                    </a>
                                </p>
                    </div>
                    <div class="col-sm-7">
                        <br><br><br><br>
                        <div class="row mt-5">
                            <div class="col-sm-6">
                            <img src="/assets/images/micrositio/micrositio42/NOTICIERO-003.png" width="100%" >
                            </div>
                            <div class="col-sm-6">
                            <img src="/assets/images/micrositio/micrositio42/NOTICIERO-004.png" width="100%" >
                            </div>
                        </div>
                        <p class="text-center text-white fontMS100Italic font-16">
                            <br>
                            <span class="text-justify ">
                                <br>
                                Logotipos de la productora Nacional Films del Perú. «Desde entonces, se hizo familiar en los cines peruanos la melodía que 
                                acompañaba los créditos de cada uno de esos noticiarios. Compuesta por el chileno Vicente Bianchi y grabada por la Orquesta 
                                Sinfónica Nacional en los estudios de Radio Nacional, la música característica precedía a la voz de J. Caycho» (Ricardo Bedoya). 

                                <br><br>
                                    Disponible en: 
                                    <a href="https://memoriaperu.bnp.gob.pe/#/micrositio18/noticieros" target="_blank" style="color: #ffffff;">
                                        Micrositio «Reportaje y propaganda: noticiarios cinematográficos peruanos de los 40
                                    </a>
                                <br><br>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <img src="/assets/images/micrositio/micrositio42/NOTICIERO_LINEA_004.png" class="reflejo"
                    width="90%" style="margin-left: 5%">
</div>

<div class="fondoBlanco">
    <div class="container">
                <div class="row">

                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio42/NOTICIERO-LINEA-003.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-30">
                            LIMA: LA CIUDAD<br>
                            QUE SE FUE<br>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio42/NOTICIERO-LINEA-003.png">
                    </div>
                </div>

                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio42/NOTICIERO-LINEA-003.png">
                </div>
        
        <div class="row p-5">
            <div class="col-sm-12">
                <p class="fontMS100 font-24 text-justify">
                    <br><br>
                    ESTAS MIGRACIONES, INICIADAS EN LA DÉCADA DE 1940, AFECTARON A LA CIUDAD DE LIMA DE 
                    LA SIGUIENTE FORMA: AL AUMENTAR LA DENSIDAD POBLACIONAL, SE PROBLEMATIZÓ EL 
                    CHOQUE ENTRE CULTURAS Y ESPACIOS DE CONVIVENCIA. ESTO TAMBIÉN AFECTÓ LA FORMA 
                    URBANÍSTICA DE LA CIUDAD, QUE EMPEZÓ A EXPANDIRSE SIN PLANIFICACIÓN PREVIA DURANTE 
                    TODA LA MITAD DEL SIGLO XX. DE TAL FORMA, LA NECESIDAD DE CONFORMAR LUGARES PARA 
                    HABITAR, HIZO QUE LOS MIGRANTES SE UBICARAN EN LAS PERIFERIAS DE LA CIUDAD (LIMA 
                    NORTE, LIMA SUR, LIMA ESTE, ETC), QUE LUEGO SE TRANSFORMARON EN ASENTAMIENTOS 
                    HUMANOS, BARRIADAS, Y CON LOS AÑOS SE CONSOLIDARON COMO DISTRITOS EMERGENTES. 
                    EN ESE SENTIDO, LOS NOTICIARIOS PRODUCIDOS EN ESE CONTEXTO REFLEJARON ESTAS 
                    TRANSFORMACIONES URBANÍSTICAS.
                    <br><br>
                </p>
            </div>
        </div>
    </div>
</div>

<div class="fondoOscuro">
    <img src="/assets/images/micrositio/micrositio42/NOTICIERO_LINEA_004.png" width="90%" style="margin-left: 5%">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="row ">
                    <div class="col-sm-4">
                                <br><br>
                                <div class="row">
                                    <div class="col-sm-12 mt-5 videoReprod">
                                        <a id="123" class="video3" href="https://www.youtube.com/embed/_jx8NbfkzX0" target="_blank" style="color: black;">
                                            <img width="100%" src="https://img.youtube.com/vi/_jx8NbfkzX0/hqdefault.jpg" />
                                        </a>
                                    </div>
                                </div>
                                <p class="fontMS100Italic font-14 text-center text-white">
                                    <br>
                                    Rincones del viejo Lima. Lima[: Productora Huascarán], 194?.
                                    Video en blanco y negro. 53”. Noticiario de la década de 1940 sobre el 
                                    Cercado de Lima, muestra la plazuela y los monumentos que la 
                                    rodean. Antecede al título: «Noticiarios Peruanos». Reproducción 
                                    digital. Originalmente grabado en un rollo de película de nitrato de 
                                    celulosa de 35 mm, en formato analógico. 
                                    Archivo en formato MP4.
                                    <br><br>
                                    Disponible en: 
                                    <a href="http://hdl.handle.net/20.500.14428/79930" target="_blank" style="color: #ffffff;">
                                        Biblioteca Digital<br><br>
                                    </a>
                                </p>
                    </div>
                    <div class="col-sm-4">
                                <br><br>
                                <div class="row">
                                    <div class="col-sm-12 mt-5 videoReprod">
                                        <a id="123" class="video3" href="https://www.youtube.com/embed/10E4OGY0jsM" target="_blank" style="color: black;">
                                            <img width="100%" src="https://img.youtube.com/vi/10E4OGY0jsM/hqdefault.jpg" />
                                        </a>
                                    </div>
                                </div>
                                <p class="fontMS100Italic font-14 text-center text-white">
                                    <br>
                                    Del viejo Lima: Los Descalzos. Lima[: Productora Huascarán], 194? 
                                    Video en blanco y negro. 1´38”. Noticiario cinematográfico de la 
                                    década de 1940 sobre los rincones románticos de la Lima Vieja: La 
                                    Alameda de los Descalzos, las estatuas de mármol y la Iglesia Nuestra 
                                    Señora del Patrocinio. Reproducción digital. Originalmente grabado en 
                                    un rollo de película de nitrato de celulosa, en formato analógico.
                                    Archivo en formato MP4.
                                    <br><br>
                                    Disponible en: 
                                    <a href="http://hdl.handle.net/20.500.14428/79143" target="_blank" style="color: #ffffff;">
                                        Biblioteca Digital<br><br>
                                    </a>
                                </p>
                    </div>
                    <div class="col-sm-4">
                                <br><br>
                                <div class="row">
                                    <div class="col-sm-12 mt-5 videoReprod">
                                        <a id="123" class="video3" href="https://www.youtube.com/embed/zvF11A0lbN0" target="_blank" style="color: black;">
                                            <img width="100%" src="https://img.youtube.com/vi/zvF11A0lbN0/hqdefault.jpg" />
                                        </a>
                                    </div>
                                </div>
                                <p class="fontMS100Italic font-14 text-center text-white">
                                    <br>
                                    En los dominios de La Perricholi. Lima[: Productora Huascarán], entre 
                                    1944 y 1948. Video en blanco y negro. 1´20”. Noticiario 
                                    cinematográfico de la década de 1940 sobre la casa de la Perricholi, 
                                    se recorrieron los ambientes. En ese video se comentó acerca de los 
                                    muebles y pinturas, el carruaje con la insignia del virrey y los jardines.
                                    Reproducción digital. Originalmente grabado en un rollo de película 
                                    de nitrato de celulosa, en formato analógico.
                                    Archivo en formato MP4.
                                    <br><br>
                                    Disponible en: 
                                    <a href="https://hdl.handle.net/20.500.14428/70637" target="_blank" style="color: #ffffff;">
                                        Biblioteca Digital<br><br>
                                    </a>
                                </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <div class="row ">
                    <div class="col-sm-4">
                                <br><br>
                                <div class="row">
                                    <div class="col-sm-12 mt-5 videoReprod">
                                        <a id="123" class="video3" href="https://www.youtube.com/embed/UKaxXmYh64o" target="_blank" style="color: black;">
                                            <img width="100%" src="https://img.youtube.com/vi/UKaxXmYh64o/hqdefault.jpg " />
                                        </a>
                                    </div>
                                </div>
                                <p class="fontMS100Italic font-14 text-center text-white">
                                    <br>
                                    Toros en Acho. Lima[: Productora Huascarán], 194? Video en blanco y
                                    negro. 2´46”. Noticiario cinematográfico de la década de 1940 sobre la 
                                    corrida de toros en la plaza de Acho y el desempeño de los jóvenes 
                                    toreros. Antecede al título: «Noticiarios Peruanos». 
                                    Reproducción digital. Originalmente grabado en un rollo de película de 
                                    nitrato de celulosa de 35 mm, en formato analógico.
                                    Archivo en formato MP4
                                    <br><br>
                                    Disponible en: 
                                    <a href="http://hdl.handle.net/20.500.14428/79932" target="_blank" style="color: #ffffff;">
                                        Biblioteca Digital<br><br>
                                    </a>
                                </p>
                    </div>
                    <div class="col-sm-4">
                                <br><br>
                                <div class="row">
                                    <div class="col-sm-12 mt-5 videoReprod">
                                        <a id="123" class="video3" href="https://www.youtube.com/embed/O4JhsxaqTMQ" target="_blank" style="color: black;">
                                            <img width="100%" src="https://img.youtube.com/vi/O4JhsxaqTMQ/hqdefault.jpg" />
                                        </a>
                                    </div>
                                </div>
                                <p class="fontMS100Italic font-14 text-center text-white">
                                    <br>
                                    Carnaval de 1948 en Lima. Lima[: Productora Huascarán], 1948. Video 
                                    en blanco y negro. 3´32”. Noticiario cinematográfico de la década de 
                                    1940 sobre el carnaval realizado en el local del club Lawn Tennis, 
                                    evento en el que se aprecia el desfile de niños disfrazados, el baile 
                                    infantil, réplica de un barco pirata, desfile de carros alegóricos 
                                    tripulados por sus reinas y sus cortes.
                                    Reproducción digital. Originalmente grabado en un rollo de película de 
                                    nitrato de celulosa en formato analógico
                                    <br><br>
                                    Disponible en: 
                                    <a href="http://hdl.handle.net/20.500.14428/80137" target="_blank" style="color: #ffffff;">
                                        Biblioteca Digital<br><br>
                                    </a>
                                </p>
                    </div>
                    <div class="col-sm-4">
                                <br><br>
                                <div class="row">
                                    <div class="col-sm-12 mt-5 videoReprod">
                                        <a id="123" class="video3" href="https://www.youtube.com/embed/VwcMlAatM9o" target="_blank" style="color: black;">
                                            <img width="100%" src="https://img.youtube.com/vi/VwcMlAatM9o/hqdefault.jpg" />
                                        </a>
                                    </div>
                                </div>
                                <p class="fontMS100Italic font-14 text-center text-white">
                                    <br>
                                    Playa de La Herradura. Lima[: Productora Huascarán], entre 1944 y 
                                    1948. Video en blanco y negro. 1´28”. Noticiario cinematográfico de la 
                                    década de 1940 que describe los atractivos del balneario La 
                                    Herradura. Antecede al título: «Noticiarios Peruanos».
                                    Reproducción digital. Originalmente grabado en un rollo de película de 
                                    nitrato de celulosa, en formato analógico.
                                    Archivo en formato MP4.
                                    <br><br>
                                    Disponible en: 
                                    <a href="http://hdl.handle.net/20.500.14428/79525" target="_blank" style="color: #ffffff;">
                                        Biblioteca Digital<br><br>
                                    </a>
                                </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <img src="/assets/images/micrositio/micrositio42/NOTICIERO_LINEA_004.png" class="reflejo"
                    width="90%" style="margin-left: 5%">
</div>

<div class="fondoBlanco">
    <div class="container">
                <div class="row">

                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio42/NOTICIERO-LINEA-003.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 280%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-30">
                            EL PERÚ PROFUNDO<br>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio42/NOTICIERO-LINEA-003.png">
                    </div>
                </div>

                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio42/NOTICIERO-LINEA-003.png">
                </div>
        
        <div class="row p-5">
            <div class="col-sm-12">
                <p class="fontMS100 font-24 text-justify">
                    <br><br>
                    EN LA DÉCADA DE 1940, EL DENOMINADO «PERÚ PROFUNDO» —REFERIDO A LA REGIONES 
                    ALEJADAS DE LA ZONA COSTEÑA— SEGUÍA DOMINADO POR ESTRUCTURAS SOCIALES 
                    TRADICIONALES, UNA ECONOMÍA BASADA EN LA AGRICULTURA Y EL LATIFUNDIO, Y UNA 
                    PROFUNDA DESIGUALDAD. LA MAYORÍA DE LA POBLACIÓN VIVÍA BAJO CONDICIONES DE 
                    SERVIDUMBRE EN HACIENDAS, MIENTRAS QUE EL ESTADO MANTENÍA UNA RELACIÓN DISTANTE 
                    CON ESTAS COMUNIDADES, QUE CONSERVABAN SUS COSTUMBRES Y LENGUAS ORGINARIAS.
                    <br><br>
                    A PESAR DE LA MARGINACIÓN, LA IDENTIDAD CULTURAL ANDINA SE MANTENÍA VIVA A TRAVÉS 
                    DE LA MÚSICA, LA DANZA, EL QUECHUA Y LAS FESTIVIDADES RELIGIOSAS SINCRÉTICAS. SIN 
                    EMBARGO, LA MIGRACIÓN HACIA LIMA Y OTRAS CIUDADES COMENZÓ A INTENSIFICARSE, 
                    MARCANDO EL INICIO DE UNA TRANSFORMACIÓN SOCIAL QUE DÉCADAS DESPUÉS CAMBIARÍA 
                    EL ROSTRO DEL PAÍS.
                    <br><br>
                </p>
            </div>
        </div>
    </div>
</div>

<div class="fondoOscuro">
    <img src="/assets/images/micrositio/micrositio42/NOTICIERO_LINEA_004.png" width="90%" style="margin-left: 5%">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="row ">
                    <div class="col-sm-4">
                                <br><br>
                                <div class="row">
                                    <div class="col-sm-12 mt-5 videoReprod">
                                        <a id="123" class="video3" href="https://www.youtube.com/embed/6alJKEm0x3M" target="_blank" style="color: black;">
                                            <img width="100%" src="https://img.youtube.com/vi/6alJKEm0x3M/hqdefault.jpg" />
                                        </a>
                                    </div>
                                </div>
                                <p class="fontMS100Italic font-14 text-center text-white">
                                    <br>
                                    Provincia de Pacasmayo. Lima[: Perú Sono Film], 194? Video en blanco 
                                    y negro. 4´46”. Noticiario cinematográfico de la década de 1940 que 
                                    describe la provincia de Pacasmayo (La Libertad).
                                    Reproducción digital. Originalmente grabado en un rollo de película de 
                                    nitrato de celulosa de 35 mm, en formato analógico.
                                    Archivo en formato MP4.
                                    <br><br>
                                    Disponible en: 
                                    <a href="http://hdl.handle.net/20.500.14428/79939" target="_blank" style="color: #ffffff;">
                                        Biblioteca Digital<br><br>
                                    </a>
                                </p>
                    </div>
                    <div class="col-sm-4">
                                <br><br>
                                <div class="row">
                                    <div class="col-sm-12 mt-5 videoReprod">
                                        <a id="123" class="video3" href="https://www.youtube.com/embed/tiXp8tMiTXA" target="_blank" style="color: black;">
                                            <img width="100%" src="https://img.youtube.com/vi/tiXp8tMiTXA/hqdefault.jpg" />
                                        </a>
                                    </div>
                                </div>
                                <p class="fontMS100Italic font-14 text-center text-white">
                                    <br>
                                    Tejidos de paja en Chiclayo. Lima[: Productora Huascarán], 1946? 
                                    Video en blanco y negro. 1´56”. Noticiario cinematográfico de la 
                                    década de 1940 sobre el éxito de la segunda "Exposición de tejidos de 
                                    paja" realizada en Chiclayo, a la que asistieron exponentes de 
                                    Lambayeque y departamentos confines. Menciona que la exposición 
                                    superó las expectativas y que las transacciones comerciales 
                                    alcanzaron altas sumas para el beneficio de las provincias norteñas.
                                    Archivo en formato MP4.
                                    <br><br>
                                    Disponible en: 
                                    <a href="https://hdl.handle.net/20.500.14428/70930" target="_blank" style="color: #ffffff;">
                                        Biblioteca Digital<br><br>
                                    </a>
                                </p>
                    </div>
                    <div class="col-sm-4">
                                <br><br>
                                <div class="row">
                                    <div class="col-sm-12 mt-5 videoReprod">
                                        <a id="123" class="video3" href="https://www.youtube.com/embed/ROzjNufz-x8" target="_blank" style="color: black;">
                                            <img width="100%" src="https://img.youtube.com/vi/ROzjNufz-x8/hqdefault.jpg" />
                                        </a>
                                    </div>
                                </div>
                                <p class="fontMS100Italic font-14 text-center text-white">
                                    <br>
                                    Ayacucho: ciudad legendaria. Lima[: Productora Huascarán], 194? 
                                    Video en blanco y negro. 4´08”. Noticiario cinematográfico de la 
                                    década de 1940 que describe la ciudad de Ayacucho.
                                    Antes de la pantalla de presentación del título: «Noticiarios 
                                    Peruanos. Edición Cinematográfica de Peruanidad. El cine al servicio 
                                    de la patria». Antecede al título: «Noticiarios Peruanos».
                                    Reproducción digital. Originalmente grabado en un rollo de película 
                                    de nitrato de celulosa de 35 mm, en formato analógico.
                                    Archivo en formato MP4.
                                    <br><br>
                                    Disponible en: 
                                    <a href="http://hdl.handle.net/20.500.14428/79897" target="_blank" style="color: #ffffff;">
                                        Biblioteca Digital<br><br>
                                    </a>
                                </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <div class="row ">
                    <div class="col-sm-4">
                                <br><br>
                                <div class="row">
                                    <div class="col-sm-12 mt-5 videoReprod">
                                        <a id="123" class="video3" href="https://www.youtube.com/embed/7GzqVqFbZ08" target="_blank" style="color: black;">
                                            <img width="100%" src="https://img.youtube.com/vi/7GzqVqFbZ08/hqdefault.jpg" />
                                        </a>
                                    </div>
                                </div>
                                <p class="fontMS100Italic font-14 text-center text-white">
                                    <br>
                                    Visiones de la provincia de Huancayo. Lima[: Perú Sono Film], 1940? 
                                    Video en blanco y negro. 5´54”. Noticiario cinematográfico de la 
                                    década de 1940 sobre la ciudad de Huancayo: avenidas, centros 
                                    industriales, arquitectura, iglesias, haciendas entre otros.
                                    Antes de la pantalla de presentación del título: «Noticiarios Peruanos. 
                                    Edición Cinematográfica de Peruanidad. El cine al servicio de la 
                                    patria».<br>
                                    Archivo en formato MP4
                                    <br><br>
                                    Disponible en: 
                                    <a href="http://hdl.handle.net/20.500.14428/80215" target="_blank" style="color: #ffffff;">
                                        Biblioteca Digital<br><br>
                                    </a>
                                </p>
                    </div>
                    <div class="col-sm-4">
                                <br><br>
                                <div class="row">
                                    <div class="col-sm-12 mt-5 videoReprod">
                                        <a id="123" class="video3" href="https://www.youtube.com/embed/wUtaZ7tY4iA" target="_blank" style="color: black;">
                                            <img width="100%" src="https://img.youtube.com/vi/wUtaZ7tY4iA/hqdefault.jpg" />
                                        </a>
                                    </div>
                                </div>
                                <p class="fontMS100Italic font-14 text-center text-white">
                                    <br>
                                    Excursión en la selva. Lima[: Nacional Films], 194? Video en blanco y 
                                    negro. 1´39”. Noticiario cinematográfico de la década de 1940 sobre 
                                    el recorrido por la selva peruana. Se observa el río Marañón con 
                                    embarcaciones a motor y el campamento de ingenieros para preparar 
                                    el terreno de la carretera de penetración.
                                    Antecede al título: «Noticiarios Peruanos».
                                    Archivo en formato MP4.
                                    <br><br>
                                    Disponible en: 
                                    <a href="https://hdl.handle.net/20.500.14428/71184" target="_blank" style="color: #ffffff;">
                                        Biblioteca Digital<br><br>
                                    </a>
                                </p>
                    </div>
                    <div class="col-sm-4">
                                <br><br>
                                <div class="row">
                                    <div class="col-sm-12 mt-5 videoReprod">
                                        <a id="123" class="video3" href="https://www.youtube.com/watch?v=At6CmdMpnvc" target="_blank" style="color: black;">
                                            <img width="100%" src="https://img.youtube.com/vi/At6CmdMpnvc/hqdefault.jpg" />
                                        </a>
                                    </div>
                                </div>
                                <p class="fontMS100Italic font-14 text-center text-white">
                                    <br>
                                    El Satipo. Lima[: Perú Sono Films], 194? Video en blanco y negro. 
                                    5´09”. Noticiario cinematográfico de la década de 1940 sobre las 
                                    iniciativas del gobierno en la modernización de la región de Satipo 
                                    como una comunidad próspera en industria y accesible a todo el 
                                    territorio nacional. Se observa el puente Victoria, único medio de 
                                    comunicación en la región, el pueblo con construcciones ligeras, la 
                                    escuela normal rural dirigida por maestras para aplicar el modelo de 
                                    enseñanza en base al conocimiento agrícola, el local de guardia civil, 
                                    el hospital de pueblo, la granja experimental de crianza del cebú y 
                                    plantaciones.
                                    <br><br>
                                    Disponible en: 
                                    <a href="http://hdl.handle.net/20.500.14428/79148" target="_blank" style="color: #ffffff;">
                                        Biblioteca Digital<br><br>
                                    </a>
                                </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <img src="/assets/images/micrositio/micrositio42/NOTICIERO_LINEA_004.png" class="reflejo"
                    width="90%" style="margin-left: 5%">
</div>

<div class="fondoBlanco">
    <div class="container">
                <div class="row">

                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio42/NOTICIERO-LINEA-003.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-30">
                            FIGURAS Y ASPECTOS<br>
                            DE LA VIDA PERUANA<br>
                            Y MUNDIAL<br>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio42/NOTICIERO-LINEA-003.png">
                    </div>
                </div>

                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio42/NOTICIERO-LINEA-003.png">
                </div>
        
        <div class="row p-5">
            <div class="col-sm-6">
                <p class="fontMS100 font-24 text-justify">
                    <br><br>
                    LOS NOTICIARIOS CINEMATOGRÁFICOS PERUANOS 
                    TAMBIÉN REGISTRARON LA PRESENCIA DE FIGURAS 
                    POLÍTICAS, INTELECTUALES Y ARTÍSTICAS DE 
                    RELEVANCIA NACIONAL E INTERNACIONAL.
                    ENTRE LOS PERUANOS QUE APARECIERON 
                    CONSTANTEMENTE EN LOS FILMS SE DESTACAN LOS 
                    PRESIDENTES MANUEL PRADO UGARTECHE Y JOSÉ LUIS 
                    BUSTAMANTE Y RIVERO. DEL MISMO MODO, SE 
                    REGISTRARON HOMENAJES AL GENERAL JOSÉ DE SAN 
                    MARTÍN, ANTONIO JOSÉ DE SUCRE, JOSÉ ANTONIO MIRÓ 
                    QUESADA, JULIO C. TELLO, ENTRE OTROS. EN EL ÁMBITO 
                    CULTURAL, LOS NOTICIARIOS MOSTRARON IMÁGENES
                    <br><br>
                </p>
            </div>
            <div class="col-sm-6">
                <p class="fontMS100 font-24 text-justify">
                    <br><br>
                    DEL REGRESO AL PERÚ DE ALEJANDRO GRANDA, FIGURA 
                    MÁXIMA DE LA LÍRICA NACIONAL, Y DE DEPORTISTAS 
                    COMO DANIEL CARPIO “CARPAYO”, RECONOCIDO POR 
                    HABER CRUZADO A NADO EL CANAL DE LA MANCHA. 
                    A NIVEL INTERNACIONAL, LA VISITA DEL EXPRESIDENTE 
                    NORTEAMERICANO HERBERT HOOVER FUE REGISTRADA 
                    CON INTERÉS, REFLEJANDO LA CONEXIÓN DEL PERÚ CON 
                    LOS ACONTECIMIENTOS MUNDIALES. ASIMISMO, 
                    FIGURAS DEL ESPECTÁCULO COMO BOB HOPE Y EL 
                    TORERO MANOLETE, EN SU PASO POR SUDAMÉRICA, 
                    PROMOVIERON EL INTERCAMBIO CULTURAL Y ARTÍSTICO 
                    EN LA REGIÓN.
                    <br><br>
                </p>
            </div>
        </div>
    </div>
</div>

<div class="fondoOscuro">
    <img src="/assets/images/micrositio/micrositio42/NOTICIERO_LINEA_004.png" width="90%" style="margin-left: 5%">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="row ">
                    <div class="col-sm-6">
                                <br><br>
                                <div class="row">
                                    <div class="col-sm-12 mt-5 videoReprod">
                                        <a id="123" class="video3" href="https://www.youtube.com/embed/nBFOkYPlNjA" target="_blank" style="color: black;">
                                            <img width="100%" src="https://img.youtube.com/vi/nBFOkYPlNjA/hqdefault.jpg" />
                                        </a>
                                    </div>
                                </div>
                                <p class="fontMS100Italic font-14 text-center text-white">
                                    <br>
                                    Homenaje al libertador don José de San Martín. Lima[: Nacional Films del Perú], 194? Video en blanco 
                                    y negro. 1´23”. Noticiario cinematográfico de la década de 1940 sobre la ceremonia en honor al prócer 
                                    argentino don José de San Martín por la proclamación de la Independencia del Perú.
                                    Reproducción digital. Originalmente grabado en un rollo de película de nitrato de celulosa, en formato 
                                    analógico.<br>
                                    Archivo en formato MP4.
                                    <br><br>
                                    Disponible en: 
                                    <a href="http://hdl.handle.net/20.500.14428/79153" target="_blank" style="color: #ffffff;">
                                        Biblioteca Digital<br><br>
                                    </a>
                                </p>
                    </div>
                    <div class="col-sm-6">
                                <br><br>
                                <div class="row">
                                    <div class="col-sm-12 mt-5 videoReprod">
                                        <a id="123" class="video3" href="https://www.youtube.com/embed/R3TH1YFIRkQ" target="_blank" style="color: black;">
                                            <img width="100%" src="https://img.youtube.com/vi/R3TH1YFIRkQ/hqdefault.jpg" />
                                        </a>
                                    </div>
                                </div>
                                <p class="fontMS100Italic font-14 text-center text-white">
                                    <br>
                                    Centenario del nacimiento de don José Antonio Miró Quesada. Lima[: Productora Huascarán], 1945? 
                                    Video en blanco y negro. 43”. Noticiario cinematográfico de la década de 1940 sobre el homenaje a 
                                    José Antonio Miró Quesada por el centenario de su nacimiento. La ceremonia fue dirigida por el Dr. 
                                    Manuel Vicente Villarán, participaron en el discurso los doctores Víctor Andrés Belaúnde y Guillermo 
                                    Hoyos Osores quienes destacaron los servicios del director y fundador de El Comercio.
                                    Reproducción digital. Originalmente grabado en un rollo de película de nitrato de celulosa, en formato 
                                    analógico.<br>
                                    Archivo en formato MP4.
                                    <br><br>
                                    Disponible en: 
                                    <a href="http://hdl.handle.net/20.500.14428/79139" target="_blank" style="color: #ffffff;">
                                        Biblioteca Digital<br><br>
                                    </a>
                                </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <div class="row ">
                    <div class="col-sm-6">
                                <br><br>
                                <div class="row">
                                    <div class="col-sm-12 mt-5 videoReprod">
                                        <a id="123" class="video3" href="https://www.youtube.com/embed/hhepQFVCp_w" target="_blank" style="color: black;">
                                            <img width="100%" src="https://img.youtube.com/vi/hhepQFVCp_w/hqdefault.jpg" />
                                        </a>
                                    </div>
                                </div>
                                <p class="fontMS100Italic font-14 text-center text-white">
                                    <br>
                                    Bob Hope en Lima. Lima[: Perú Sono Films], 194? Video en blanco y negro. 47”.
                                    Noticiario cinematográfico de la década de 1940 sobre la visita del célebre actor Bob Hope a Lima, 
                                    acompañado de su esposa y el gerente de Paramount Pictures. Reproducción digital. Originalmente 
                                    grabado en un rollo de película de nitrato de celulosa de 35 mm, en formato analógico.
                                    Archivo en formato MP4.
                                    <br><br>
                                    Disponible en: 
                                    <a href="http://hdl.handle.net/20.500.14428/79917" target="_blank" style="color: #ffffff;">
                                        Biblioteca Digital<br><br>
                                    </a>
                                </p>
                    </div>
                    <div class="col-sm-6">
                                <br><br>
                                <div class="row">
                                    <div class="col-sm-12 mt-5 videoReprod">
                                        <a id="123" class="video3" href="https://www.youtube.com/embed/skps0ftz-mY" target="_blank" style="color: black;">
                                            <img width="100%" src="https://img.youtube.com/vi/skps0ftz-mY/hqdefault.jpg" />
                                        </a>
                                    </div>
                                </div>
                                <p class="fontMS100Italic font-14 text-center text-white">
                                    <br>
                                    Llegada de Hoover. Lima [: Productora Huascarán], 1946. Video en blanco y negro. 58”. 
                                    Noticiario cinematográfico de la década de 1940 sobre la visita del expresidente de los Estados Unidos, 
                                    estadista y presidente de la UNRRA (United Nations Relief Rehabilitation Administration – 
                                    Administración de Socorro y Rehabilitación de las Naciones Unidas) quien llegó al aeropuerto de 
                                    Limatambo y fuera recibido por ministros, embajadores y miembros de la esfera política y social. Su 
                                    visita a Lima tuvo como objetivo recaudar ayuda para las naciones devastadas por la Segunda Guerra 
                                    Mundial. Reproducción digital. Originalmente grabado en un rollo de película de nitrato de celulosa, 
                                    en formato analógico.<br>
                                    Archivo en formato MP4.
                                    <br><br>
                                    Disponible en: 
                                    <a href="https://hdl.handle.net/20.500.14428/71038" target="_blank" style="color: #ffffff;">
                                        Biblioteca Digital<br><br>
                                    </a>
                                </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <img src="/assets/images/micrositio/micrositio42/NOTICIERO_LINEA_004.png" class="reflejo"
                    width="90%" style="margin-left: 5%">
</div>

<div class="fondoBlanco">
    <div class="container">
                <div class="row">

                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio42/NOTICIERO-LINEA-003.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-30">
                            FORJANDO EL FUTURO:<br>
                            LA EDUCACIÓN PERUANA<br>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio42/NOTICIERO-LINEA-003.png">
                    </div>
                </div>

                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio42/NOTICIERO-LINEA-003.png">
                </div>
        
        <div class="row p-5">
            <div class="col-sm-12">
                <p class="fontMS100 font-24 text-justify">
                    <br><br>
                    EL REGISTRO FÍLMICO CAPTURÓ EL AVANCE DE LOS PROCESOS DE MODERNIZACIÓN URBANA Y LA EXPANSIÓN DE LOS 
                    SERVICIOS PÚBLICOS MEDIANTE GRANDES OBRAS DE INFRAESTRUCTURA QUE EVIDENCIARON EL ROL DEL ESTADO 
                    PERUANO EN LA GESTIÓN DE RECURSOS Y LA DISTRIBUCIÓN DE BIENES.<br>
                    LOS NOTICIARIOS TAMBIÉN PRESENTAN ALGUNAS DE LAS ACCIONES EFECTUADAS POR LOS GOBIERNOS DE PRADO Y 
                    BUSTAMANTE Y RIVERO REFERIDAS AL IMPULSO DE LA EDUCACIÓN TÉCNICA Y NORMAL, AL ESTABLECIMIENTO DE LA 
                    EDUCACIÓN INFANTIL PARA NIÑOS DE CUATRO A SIETE AÑOS, LA APERTURA DEL MAGISTERIO A LAS CLASES MEDIAS Y LA 
                    GRATUIDAD DE LA EDUCACIÓN SECUNDARIA PARA LOS ALUMNOS EGRESADOS DE LAS ESCUELAS FISCALES.
                    <br><br>
                </p>
            </div>
        </div>
    </div>
</div>

<div class="fondoOscuro">
    <img src="/assets/images/micrositio/micrositio42/NOTICIERO_LINEA_004.png" width="90%" style="margin-left: 5%">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="row ">
                    <div class="col-sm-4">
                                <br><br>
                                <div class="row">
                                    <div class="col-sm-12 mt-5 videoReprod">
                                        <a id="123" class="video3" href="https://www.youtube.com/embed/uGmDSED1Yh4" target="_blank" style="color: black;">
                                            <img width="100%" src="https://img.youtube.com/vi/uGmDSED1Yh4/hqdefault.jpg" />
                                        </a>
                                    </div>
                                </div>
                                <p class="fontMS100Italic font-14 text-center text-white">
                                    <br>
                                    Un día en el Jardín de la Infancia N° 1: el Perú defiende la salud y 
                                    educación de sus niños. Lima[: National Films del Perú], 194? Video 
                                    en blanco y negro. 7´19”. <br>
                                    Noticiario cinematográfico de la década de 1940 sobre la educación 
                                    que reciben los niños en este centro educativo fundado en 1930. El 
                                    video informa que existen 87 jardines distribuidos en el país, en los 
                                    que se da atención médica a los escolares y cursos técnicos. 
                                    Menciona que también se enseña a las madres nociones sobre la 
                                    preparación de alimentos para sus hijos y otras tareas domésticas.
                                    Reproducción digital. Originalmente grabado en un rollo de película 
                                    de nitrato de celulosa en formato analógico.
                                    Archivo en formato MP4.
                                    <br><br>
                                    Disponible en: 
                                    <a href="http://hdl.handle.net/20.500.14428/79901" target="_blank" style="color: #ffffff;">
                                        Biblioteca Digital<br><br>
                                    </a>
                                </p>
                    </div>
                    <div class="col-sm-4">
                                <br><br>
                                <div class="row">
                                    <div class="col-sm-12 mt-5 videoReprod">
                                        <a id="123" class="video3" href="https://www.youtube.com/embed/yQmHu32Fmbw" target="_blank" style="color: black;">
                                            <img width="100%" src="https://img.youtube.com/vi/yQmHu32Fmbw/hqdefault.jpg" />
                                        </a>
                                    </div>
                                </div>
                                <p class="fontMS100Italic font-14 text-center text-white">
                                    <br>
                                    Gran demostración gimnástica escolar en Lima. Lima[: Productora no 
                                    identificada], 1940? Video en blanco y negro. 3´07”. 
                                    Noticiario cinematográfico de la década de 1940 sobre la exhibición 
                                    gimnástica escolar en el Estadio Nacional, organizada por la Dirección 
                                    de Educación Física e Higiene Escolar del Ministerio de Educación 
                                    Pública. Los alumnos de diversos centros escolares nacionales y 
                                    particulares así como de escuelas industriales demostraron una serie 
                                    de ejercicios utilizando algunos materiales. Destacaron en esta 
                                    presentación los alumnos del colegio Alfonso Ugarte y del colegio 
                                    Militar Leoncio Prado.<br>
                                    Reproducción digital. Originalmente grabado en un rollo de película 
                                    de nitrato de celulosa en formato analógico.
                                    Archivo en formato MP4.
                                    <br><br>
                                    Disponible en: 
                                    <a href="http://hdl.handle.net/20.500.14428/80142" target="_blank" style="color: #ffffff;">
                                        Biblioteca Digital<br><br>
                                    </a>
                                </p>
                    </div>
                    <div class="col-sm-4">
                                <br><br>
                                <div class="row">
                                    <div class="col-sm-12 mt-5 videoReprod">
                                        <a id="123" class="video3" href="https://www.youtube.com/embed/MymxGuapBi4" target="_blank" style="color: black;">
                                            <img width="100%" src="https://img.youtube.com/vi/MymxGuapBi4/hqdefault.jpg" />
                                        </a>
                                    </div>
                                </div>
                                <p class="fontMS100Italic font-14 text-center text-white">
                                    <br>
                                    Fiesta anual de los exalumnos del Colegio Sabogal – Callao. Lima[: 
                                    Productora Huascarán], 1940. Video en blanco y negro. 1´06”.
                                    Noticiario cinematográfico de la década de 1940 sobre el encuentro 
                                    de los exalumnos del Colegio Sabogal, actualmente Instituto Sabogal, 
                                    por el cuadragésimo quinto aniversario de su fundación.
                                    Antecede al título: «Noticiarios Peruanos. Edición Cinematográfica de 
                                    Peruanidad»<br>
                                    Reproducción digital. Originalmente grabado en un rollo de película 
                                    de nitrato de celulosa, en formato analógico.
                                    Archivo en formato MP4. 
                                    <br><br>
                                    Disponible en: 
                                    <a href="http://hdl.handle.net/20.500.14428/79553" target="_blank" style="color: #ffffff;">
                                        Biblioteca Digital<br><br>
                                    </a>
                                </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <div class="row ">
                    <div class="col-sm-4">
                                <br><br>
                                <div class="row">
                                    <div class="col-sm-12 mt-5 videoReprod">
                                        <a id="123" class="video3" href="https://www.youtube.com/embed/ZdzkmQCuKfY" target="_blank" style="color: black;">
                                            <img width="100%" src="https://img.youtube.com/vi/ZdzkmQCuKfY/hqdefault.jpg" />
                                        </a>
                                    </div>
                                </div>
                                <p class="fontMS100Italic font-14 text-center text-white">
                                    <br>
                                    Colegio Agropecuario de San Juan (Matucana). Lima[: Productora 
                                    Huascarán], 1940? Video en blanco y negro. 1´33”. 
                                    Noticiario cinematográfico de la década de 1940 sobre la ampliación 
                                    del Colegio Agropecuario N° 27 de San Juan de Matucana como parte 
                                    del programa de la industrialización del país.
                                    Antes de la pantalla de presentación del título: «Noticiarios 
                                    Peruanos». <br>
                                    Reproducción digital. Originalmente grabado en un rollo de película de 
                                    nitrato de celulosa en formato analógico.
                                    Archivo en formato MP4.
                                    <br><br>
                                    Disponible en: 
                                    <a href="http://hdl.handle.net/20.500.14428/80216" target="_blank" style="color: #ffffff;">
                                        Biblioteca Digital<br><br>
                                    </a>
                                </p>
                    </div>
                    <div class="col-sm-4">
                                <br><br>
                                <div class="row">
                                    <div class="col-sm-12 mt-5 videoReprod">
                                        <a id="123" class="video3" href="https://www.youtube.com/embed/g77U0OK_ZOA" target="_blank" style="color: black;">
                                            <img width="100%" src="https://img.youtube.com/vi/g77U0OK_ZOA/hqdefault.jpg" />
                                        </a>
                                    </div>
                                </div>
                                <p class="fontMS100Italic font-14 text-center text-white">
                                    <br>
                                    Convención Nacional de Educación. Lima[: Productora Huascarán], 
                                    entre 1945 y 1948. Video en blanco y negro. 39”.
                                    Noticiario cinematográfico de la década de 1940 sobre la primera 
                                    Convención Nacional de Educación, realizada en el balneario de 
                                    Miraflores donde asistieron delegados apristas del país y se trataron 
                                    temas en pro del futuro de la educación nacional.
                                    Antecede al título: «Noticiarios Peruanos».<br>
                                    Reproducción digital. Originalmente grabado en un rollo de película 
                                    de nitrato de celulosa, en formato analógico.
                                    Archivo en formato MP4.
                                    <br><br>
                                    Disponible en: 
                                    <a href="http://hdl.handle.net/20.500.14428/79542" target="_blank" style="color: #ffffff;">
                                        Biblioteca Digital<br><br>
                                    </a>
                                </p>
                    </div>
                    <div class="col-sm-4">
                                <br><br>
                                <div class="row">
                                    <div class="col-sm-12 mt-5 videoReprod">
                                        <a id="123" class="video3" href="https://www.youtube.com/embed/Tt5afRrcbhE" target="_blank" style="color: black;">
                                            <img width="100%" src="https://img.youtube.com/vi/Tt5afRrcbhE/hqdefault.jpg" />
                                        </a>
                                    </div>
                                </div>
                                <p class="fontMS100Italic font-14 text-center text-white">
                                    <br>
                                    Convención de maestros. Lima[: Productora Huascarán], entre 1944 y 
                                    1945. Video en blanco y negro. 58”.
                                    Noticiario cinematográfico de la década de 1940 sobre la sesión 
                                    preparatoria de la Convención de directores de colegios nacionales, 
                                    organizada en el salón de actos del Colegio Nacional Nuestra Señora 
                                    de Guadalupe. Esta sesión fue presidida por el director de Educación 
                                    Común, el Dr. Francisco Cadenillas. Se trataron temas de importancia 
                                    para la educación nacional y se nombró al presidente de la República, 
                                    Manuel Prado Ugarteche como presidente honorario y al ministro de 
                                    Educación, Enrique Laroza, como vicepresidente honorario.
                                    Antecede al título: «Noticiarios Peruanos. Edición Cinegráfica de 
                                    Peruanidad». <br>
                                    Reproducción digital. Originalmente grabado en un rollo de película de 
                                    nitrato de celulosa, en formato analógico.
                                    Archivo en formato MP4.
                                    <br><br>
                                    Disponible en: 
                                    <a href="http://hdl.handle.net/20.500.14428/79543" target="_blank" style="color: #ffffff;">
                                        Biblioteca Digital<br><br>
                                    </a>
                                </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <img src="/assets/images/micrositio/micrositio42/NOTICIERO_LINEA_004.png" class="reflejo"
                    width="90%" style="margin-left: 5%">
</div>

<div class="fondoBlanco">
    <div class="container">
                <div class="row">

                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio42/NOTICIERO-LINEA-003.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-30">
                            TESTIMONIOS DE<br>
                            RELIGIOSIDAD<br>
                        </p>
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio42/NOTICIERO-LINEA-003.png">
                    </div>
                </div>

                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio42/NOTICIERO-LINEA-003.png">
                </div>
        
        <div class="row p-5">
            <div class="col-sm-12">
                <p class="fontMS100 font-24 text-center">
                    <br><br>
                    AL SER EL PERÚ UN PAÍS CON UNA FUERTE HERENCIA RELIGIOSA, ESTOS NOTICIARIOS CAPTURARON PARA LA 
                    POSTERIDAD DIVERDAD MANIFESTACIONES DE CULTO EN LAS REGIONES DEL PAÍS.
                    LA RELIGIOSIDAD POPULAR EN EL PERÚ DE LA DÉCADA DEL CUARENTA ESTUVO MARCADA POR UNA PROFUNDA 
                    DEVOCIÓN Y UNA SERIE DE FESTIVIDADES QUE CONGREGARON A MILES DE FIELES EN DISTINTAS REGIONES DEL PAÍS. 
                    ENTRE ESTAS CELEBRACIONES, DESTACABAN LA SEMANA SANTA EN AYACUCHO, LA PROCESIÓN DEL SEÑOR DE LOS 
                    MILAGROS EN LIMA, LA PROCESIÓN DEL SEÑOR DE LUREN EN ICA, LA PROCESIÓN DE SANTA ROSA DE LIMA, EL TE DEUM 
                    DE 1947 Y EL CULTO A LA VIRGEN DE LA PUERTA EN OTUZCO.
                    <br><br>
                </p>
            </div>
        </div>
        <div class="col-sm-12 d-none d-md-block">
                <div class="image-container">
                    <img class="bg-image" src="/assets/images/micrositio/micrositio42/NOTICIERO-002.png" alt="Noticiero">
                    <div class="text-overlay2">
                        <div class="row">
                            <div class="col-sm-12 mt-5 videoReprod">
                                <a id="123" class="video3" href="https://www.youtube.com/embed/QoyBatGcOLM" target="_blank" style="color: black;">
                                    <img width="100%" src="https://img.youtube.com/vi/QoyBatGcOLM/hqdefault.jpg" />
                                </a>
                            </div>
                        </div>
                        <p class="fontMS100Italic font-14 text-center">
                            <br>
                            Semana Santa en Ayacucho. Lima[: Productora Huascarán], 194? Video en blanco y negro. 3´46”.
                            Noticiario cinematográfico de la década de 1940 sobre las actividades realizadas en Ayacucho por Semana Santa, como la procesión del 
                            Señor de la Resurrección, la asistencia oficial de las autoridades políticas y familias destacadas del distrito a la misa y la Feria de Chupas, 
                            donde se observa a detalle el comercio de los morochucos.<br>
                            Reproducción digital. Originalmente grabado en un rollo de película de nitrato de celulosa, en formato analógico.
                            Archivo en formato MP4.
                            <br>
                        </p>
                        <p class="fontMS100Italic font-14 text-center">
                            Disponible en: 
                            <a href="https://hdl.handle.net/20.500.14428/71045" target="_blank" style="color: #ffffff;">
                                Biblioteca Digital
                            </a>
                        </p>
                    </div>
                </div>
        </div>
        <div class="col-sm-12 d-md-none">
                <div class="image-container3">
                    <div class="text-overlay3">
                        <div class="row">
                            <div class="col-sm-12 mt-5 videoReprod">
                                <a id="123" class="video3" href="https://www.youtube.com/embed/QoyBatGcOLM" target="_blank" style="color: black;">
                                    <img width="100%" src="https://img.youtube.com/vi/QoyBatGcOLM/hqdefault.jpg" />
                                </a>
                            </div>
                        </div>
                        <p class="fontMS100Italic font-16 text-center">
                            Semana Santa en Ayacucho. Lima[: Productora Huascarán], 194? Video en blanco y negro. 3´46”.
                            Noticiario cinematográfico de la década de 1940 sobre las actividades realizadas en Ayacucho por Semana Santa, como la procesión del 
                            Señor de la Resurrección, la asistencia oficial de las autoridades políticas y familias destacadas del distrito a la misa y la Feria de Chupas, 
                            donde se observa a detalle el comercio de los morochucos.<br>
                            Reproducción digital. Originalmente grabado en un rollo de película de nitrato de celulosa, en formato analógico.
                            Archivo en formato MP4.
                            <br><br>
                            Disponible en: 
                            <a href="https://hdl.handle.net/20.500.14428/71045" target="_blank" style="color: #ffffff;">
                                Biblioteca Digital
                            </a>
                        </p>
                    </div>
                </div>
        </div>

        <div class="row">
            <div class="col-sm-12">
                <div class="row ">
                    <div class="col-sm-6">
                                <br><br>
                                <div class="row">
                                    <div class="col-sm-12 mt-5 videoReprod">
                                        <a id="123" class="video3" href="https://www.youtube.com/embed/EJBwbmxx6aw" target="_blank" style="color: black;">
                                            <img width="100%" src="https://img.youtube.com/vi/EJBwbmxx6aw/hqdefault.jpg" />
                                        </a>
                                    </div>
                                </div>
                                <p class="fontMS100Italic font-14 text-center">
                                    <br>
                                    Procesión del Señor de los Milagros. Lima[: National Films del Perú], entre 1945 y 1948. 
                                    Video en blanco y negro. 1´19”. <br>
                                    Noticiario cinematográfico de la década de 1940 sobre el recorrido tradicional de la 
                                    procesión del Señor de los Milagros por las principales calles de Lima, acompañada por 
                                    sus fieles devotos. La procesión es presenciada por el jefe de Estado desde uno de los 
                                    balcones del Palacio de Gobierno.<br>
                                    Reproducción digital. Originalmente grabado en un rollo de película de nitrato de 
                                    celulosa, en formato analógico. Archivo en formato MP4.
                                    <br><br>
                                    Disponible en: 
                                    <a href="http://hdl.handle.net/20.500.14428/79560" target="_blank" style="color: #000000;">
                                        Biblioteca Digital<br><br>
                                    </a>
                                </p>
                    </div>
                    <div class="col-sm-6">
                                <br><br>
                                <div class="row">
                                    <div class="col-sm-12 mt-5 videoReprod">
                                        <a id="123" class="video3" href="https://www.youtube.com/embed/FpVmrPae_Uk" target="_blank" style="color: black;">
                                            <img width="100%" src="https://img.youtube.com/vi/FpVmrPae_Uk/hqdefault.jpg" />
                                        </a>
                                    </div>
                                </div>
                                <p class="fontMS100Italic font-14 text-center">
                                    <br>
                                    Procesión del Señor de Luren de Ica. Lima[: National Films del Perú], 194? Video en 
                                    blanco y negro. 37”. <br>
                                    Noticiario cinematográfico de la década de 1940 sobre la procesión del Señor de Luren 
                                    de Ica. Reproducción digital. Originalmente grabado en un rollo de película de nitrato 
                                    de celulosa, en formato analógico.
                                    Archivo en formato MP4.
                                    <br><br>
                                    Disponible en: 
                                    <a href="http://hdl.handle.net/20.500.14428/79522" target="_blank" style="color: #000000;">
                                        Biblioteca Digital<br><br>
                                    </a>
                                </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12">
                <div class="row ">
                    <div class="col-sm-6">
                                <br><br>
                                <div class="row">
                                    <div class="col-sm-12 mt-5 videoReprod">
                                        <a id="123" class="video3" href="https://www.youtube.com/embed/CVuolAOSxp0" target="_blank" style="color: black;">
                                            <img width="100%" src="https://img.youtube.com/vi/CVuolAOSxp0/hqdefault.jpg" />
                                        </a>
                                    </div>
                                </div>
                                <p class="fontMS100Italic font-14 text-center">
                                    <br>
                                    La tradicional procesión de Santa Rosa. Lima[: Productora Huascarán], entre 1944 y 
                                    1948. Video en blanco y negro. 1´43”.<br>
                                    Noticiario cinematográfico de la década de 1940 sobre las festividades por el día de 
                                    Santa Rosa de Lima, la misa realizada en el atrio de la Catedral, la participación de los 
                                    alumnos y la procesión religiosa por las calles de Lima.<br>
                                    Reproducción digital. Originalmente grabado en un rollo de película de nitrato de 
                                    celulosa, en formato analógico.
                                    Archivo en formato MP4.
                                    <br><br>
                                    Disponible en: 
                                    <a href="https://hdl.handle.net/20.500.14428/70655" target="_blank" style="color: #000000;">
                                        Biblioteca Digital<br><br>
                                    </a>
                                </p>
                    </div>
                    <div class="col-sm-6">
                                <br><br>
                                <div class="row">
                                    <div class="col-sm-12 mt-5 videoReprod">
                                        <a id="123" class="video3" href="https://www.youtube.com/embed/NsypNUhYB2U" target="_blank" style="color: black;">
                                            <img width="100%" src="https://img.youtube.com/vi/NsypNUhYB2U/hqdefault.jpg" />
                                        </a>
                                    </div>
                                </div>
                                <p class="fontMS100Italic font-14 text-center">
                                    <br>
                                    1821 28 de julio 1947: Te Deum. Lima[: Nacional Films del Perú], 1947. Video en blanco 
                                    y negro. 1´48”. <br>
                                    Noticiario cinematográfico de la década de 1940 sobre la asistencia del presidente José 
                                    Luis Bustamante y Rivero y su gabinete ministerial al acto religioso que se realiza en 
                                    conmemoración del día de la Independencia Nacional en la Catedral de Lima.
                                    Reproducción digital. Originalmente grabado en un rollo de película de nitrato de 
                                    celulosa en formato analógico.
                                    Archivo en formato MP4.
                                    <br><br>
                                    Disponible en: 
                                    <a href="http://hdl.handle.net/20.500.14428/80136" target="_blank" style="color: #000000;">
                                        Biblioteca Digital<br><br>
                                    </a>
                                </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoVerde">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS500 text-white font-60">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img id="img_dialogo"
                            src="\assets\images\micrositio\micrositio34\FERNANDOG-LINEA-004.png">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 p-3">
                        <p class="fontMS100 text-white font-24">
                            
                        </p>
                    </div>
                    <div class="col-sm-12 p-3">
                        <p class="fontMS300 text-white font-24 text-justify">
                            «El Ministerio de Gobierno y Policía, encargado de controlar el funcionamiento del sistema, determinaba el asunto que debían 
                            tratar los cortos, designando a la empresa productora, elegida entre las sociedades inscritas en un padrón creado al efecto. La 
                            norma legal, previendo el futuro, le encargó también al Poder Ejecutivo llevar un registro de la producción cinematográfica 
                            con el fin de organizar una Filmoteca Nacional». (Ricardo Bedoya)
                            <br><br>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4 p-3">
                        <!-- <p class="fontMS300 text-white font-22">
                            Pregunta 1:
                        </p> -->
                        <p class="fontMS300 text-white font-22">
                            Pregunta 1: ¿Qué implicancias tiene el 
                            hecho de que el Ministerio de Gobierno 
                            y Policía determinara los temas de los 
                            cortometrajes y designara a las 
                            empresas productoras?
                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-005.png">
                        </p>
                    </div>
                    <div class="col-sm-4 p-3">
                        <!-- <p class="fontMS300 text-white font-22">
                            Pregunta 2:
                        </p> -->
                        <p class="fontMS300 text-white font-22">
                            Pregunta 2: ¿Por qué crees que la 
                            norma consideró importante la 
                            creación de una Filmoteca 
                            Nacional? ¿Qué beneficios podría 
                            traer este registro para la historia y 
                            la cultura de un país?

                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-005.png">
                        </p>
                    </div>
                    <div class="col-sm-4 p-3">
                        <!-- <p class="fontMS300 text-white font-22">
                            Pregunta 3:
                        </p> -->
                        <p class="fontMS300 text-white font-22">
                            Pregunta 3: La información es un bien 
                            público, ¿cómo te mantienes 
                            informado?
                            <br><br>
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio34/FERNANDOG-LINEA-005.png">
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio42/NOTICIERO-LINEA-003.png">
                    </div>
                    <div class="col-sm-4 text-center">
                        <p style="line-height: 180%;margin-bottom: 0%;"
                            class="fontMS700 text-center  font-40" style="color:#83b27a;">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec_Izq" width="100%"
                            src="/assets/images/micrositio/micrositio42/NOTICIERO-LINEA-003.png">
                    </div>
                </div>
                <p class="fontMS100 text-left font-24">
                    <br><br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación.
                    <br><br>
                </p>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500Italic">Archivo Peruano de Imagen y Sonido. </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Disponible en:
                                <a href="http://www.archivoperuano.com/" target="_blank" style="color: #000000;"  >
                            http://www.archivoperuano.com/<br>
                                </a>
                            </span>

                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500Italic">Mejía Ticona, V. (2007). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Ilusiones a oscuras. Cines en 
                            Lima: carpas, grandes salas y multicines 1897-2007. 
                            Lima: Centro Cultural de España, Universidad Ricardo 
                            Palma, Asociación Cultural Peruano Británica, Agencia 
                            Suiza para el Desarrollo y la Cooperación COSUDE, 
                            Embajada de Francia.<br>
                                <!-- Gafas Moradas EIRL.
                                <br><br>
                                Disponible en: 
                                <a style="color: #000000;" href="https://doi.org/10.1590/1982-25532020144547" target="_blank">
                                https://doi.org/10.1590/1982-25532020144547</a>
                                <br> -->
                            </span>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500Italic">Paz, M. A. y Sánchez, I. (1999). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;"> La historia filmada: los 
                            noticiarios cinematográficos como fuente histórica. 
                            Una propuesta metodológica. Filmhistoria [online]. 
                            Vol. 9, no. 1. Disponible en: <br>
                                <a style="color: #000000;" href="https://revistes.ub.edu/index.php/filmhistoria/article/view/12366" target="_blank">
                                https://revistes.ub.edu/index.php/filmhistoria/article/view/12366</a>
                                <br>
                            </span>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500Italic">Bedoya, R. (2009). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;"> El cine sonoro en el Perú. Lima: 
                            Universidad de Lima, Fondo Editorial.
                                <!-- <a style="color: #000000;" href="https://dpalenque.com.pe/wp-content/uploads/2023/05/DPalenque-Nro-1_compressed.pdf" target="_blank">
                                https://dpalenque.com.pe/wp-content/uploads/2023/05/DPalenque-Nro-1_compressed.pdf</a> -->
                                <br>
                            </span>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500Italic">Ministerio de Justicia y Derechos Humanos (2022). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Libertad religiosa en el Perú: contexto histórico, 
                            garantías del derecho y experiencia comparada: 
                            España, Argentina, Colombia y México. Lima: 
                            Ministerio de Justicia y Derechos Humanos. <br><br>
                            </span>

                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500Italic">Subirana, K. (2017). </span>
                            <span class="fontMS100Italic text-gris" style="word-wrap: break-word;">Lima cumple 482 años: una 
                            mirada desde la historia y la arquitectura. .edu 
                            [online]. Disponible en: <br>
                                <a style="color: #000000;" href="https://puntoedu.pucp.edu.pe/noticia/lima-cumple-482-anos/" target="_blank">
                                https://puntoedu.pucp.edu.pe/noticia/lima-cumple-482-anos/</a>
                            </span>

                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>